import React from "react";

import { WSIcon } from "../core/WSIcon/WSIcon.component";
import { WSActions } from "../WSActions/WSActions";
import { WSElement } from "../WSElement/WSElement.component";

import {
  WSTableItem,
  WSTableRowActions,
  WSTableRowFetchMenuActions,
  WSTableRowMenuActions
} from "./types";
import styles from "./WSTable.module.scss";


type RowActionsProps = {
  item: WSTableItem;
  getRowMenuActionsDisabled?: (item: WSTableItem) => boolean | undefined;
  rowMenuActions?: WSTableRowMenuActions<any>;
  rowFetchMenuActions?: WSTableRowFetchMenuActions<any>;
  rowMenuLoadingText?: string;
  rowMenuErrorText?: string;
  onRowMenuError?: (error: Error, item: WSTableItem) => void;
  rowActions?: WSTableRowActions<any>;
  onRowClick?: (item: WSTableItem) => void;
  getOnRowClick?: (
    item: WSTableItem
  ) => ((item: WSTableItem) => void) | undefined;
  disabled?: boolean;
};

export const RowActions: React.FC<RowActionsProps> = ({
  item,
  rowActions,
  rowMenuActions,
  rowFetchMenuActions,
  getRowMenuActionsDisabled,
  rowMenuLoadingText,
  rowMenuErrorText,
  onRowMenuError,
  onRowClick,
  getOnRowClick,
  disabled: externalDisabled
}) => {
  const actions = rowActions?.(item);
  const menuActions = rowMenuActions?.(item);
  const fetchMenuActions = rowFetchMenuActions
    ? () => rowFetchMenuActions(item)
    : undefined;

  const handleRowClick = getOnRowClick?.(item)
    ? () => getOnRowClick(item)?.(item)
    : onRowClick
    ? () => onRowClick?.(item)
    : undefined;

  const disabled = getRowMenuActionsDisabled?.(item) || externalDisabled;

  return (
    <>
      <WSElement className={styles.rowActions}>
        <WSActions
          disabled={disabled}
          alignment="right"
          size="S"
          buttons={actions?.map((action, index) => ({
            label: action.text,
            hideOn: ["XS"],
            kind: "Link",
            type: "button",
            ...action,
            disabled
          }))}
          {...(fetchMenuActions
            ? {
                fetchMenuItems: fetchMenuActions,
                menuLoadingText: rowMenuLoadingText,
                menuErrorText: rowMenuErrorText,
                onMenuError: onRowMenuError
                  ? (error) => onRowMenuError(error, item)
                  : undefined
              }
            : { menuItems: menuActions })}
        />

        {!!(onRowClick || getOnRowClick) && (
          <WSIcon
            onClick={handleRowClick}
            block
            name="chevron-right"
            color={handleRowClick ? "gray500" : "transparent"}
            size="S"
          />
        )}
      </WSElement>
    </>
  );
};
